import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { NavBar } from './components/navbar/navbar';
import reportWebVitals from './reportWebVitals';
import { Banner } from './components/banner/banner';

const root = ReactDOM.createRoot(document.getElementById('nav'));
root.render(
  <React.StrictMode>
    <NavBar />
    <Banner />
  </React.StrictMode>
);




// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
